import { createFileRoute } from "@tanstack/react-router";
import ExperimentDetailPage from "../pages/Experiments/ExperimentDetailPage";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/experiments/$experimentId")({
  component: ExperimentDetailRoute,
});

function ExperimentDetailRoute() {
  return (
    <RequireAuth require="experimentsManage">
      <ExperimentDetailPage />
    </RequireAuth>
  );
}
